module.exports = __webpack_public_path__ + "static/media/ggsipuLogo.bf2cae4e.png";